<template>
  <div class="pagination" v-if="totalPages > 1">
    <div class="pagination-center">
      <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1 || isPrevLoading">
        <LoadingSpinner v-if="isPrevLoading" :visible="true" :inline="true" />
        <span v-else-if="!isMobile">上一页</span>
        <span v-else>&lt;</span>
      </button>

      <span class="page-info">
        <input
          type="number"
          class="page-jump-input"
          v-model.number="jumpPageInput"
          :min="1"
          :max="totalPages"
          @keyup.enter="handleJump"
          @blur="validateAndCorrectJumpInput"
          aria-label="跳转到指定页码"
          :disabled="isJumpLoading"
        />
        / {{ totalPages }}
      </span>

      <button @click="handleJump" :disabled="!isValidJumpInput || isJumpLoading">
        <LoadingSpinner v-if="isJumpLoading" :visible="true" :inline="true" />
        <span v-else>跳转</span>
      </button>

      <button @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages || isNextLoading">
        <LoadingSpinner v-if="isNextLoading" :visible="true" :inline="true" />
        <span v-else-if="!isMobile">下一页</span>
        <span v-else>&gt;</span>
      </button>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from './LoadingSpinner.vue';

export default {
  name: 'PaginationControls',
  components: {
    LoadingSpinner
  },
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    isMobile: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    isPageLoading: { type: Boolean, default: false },
    isPrevLoading: { type: Boolean, default: false },
    isNextLoading: { type: Boolean, default: false },
    isJumpLoading: { type: Boolean, default: false }
  },
  data() {
    return {
      jumpPageInput: this.currentPage
    };
  },
  watch: {
    currentPage(newPage) {
      this.jumpPageInput = newPage;
    }
  },
  computed: {
    isValidJumpInput() {
      const page = parseInt(this.jumpPageInput, 10);
      return !isNaN(page) && page >= 1 && page <= this.totalPages;
    }
  },
  methods: {
    goToPage(pageNumber) {
      if (pageNumber >= 1 && pageNumber <= this.totalPages && pageNumber !== this.currentPage) {
        // 直接emit事件，让父组件处理loading状态
        this.$emit('page-changed', pageNumber);
      }
    },
    handleJump() {
      this.validateAndCorrectJumpInput();
      const page = parseInt(this.jumpPageInput, 10);
      if (this.isValidJumpInput && page !== this.currentPage) {
        // 直接emit事件，让父组件处理loading状态
        this.$emit('page-changed', page);
      } else if (page === this.currentPage) {
        this.jumpPageInput = this.currentPage;
      }
    },
    validateAndCorrectJumpInput() {
      let page = parseInt(this.jumpPageInput, 10);
      if (isNaN(page) || page < 1) {
        this.jumpPageInput = 1;
      } else if (page > this.totalPages) {
        this.jumpPageInput = this.totalPages;
      } else {
        this.jumpPageInput = page;
      }
    }
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  flex-wrap: wrap;
}

.pagination-center {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.pagination button {
  background-color: #2e3968;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
  font-size: 14px;
  line-height: 1.2;
}
.pagination button:hover:not(:disabled) {
  background-color: #f0f0f0;
  color: #2e3968;
}
.pagination button:disabled {
  background-color: #eef0f6;
  color: #c0c4cc;
  border-color: #dcdfe6;
  opacity: 0.7;
  cursor: not-allowed;
}
.page-info {
  font-weight: bold;
  color: #2e3968;
  font-size: 14px;
  margin: 0 8px;
  display: flex;
  align-items: center;
}

.page-jump-input {
  width: 50px;
  text-align: center;
  margin: 0 5px;
  padding: 8px 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.2;
  box-sizing: border-box;
}

.page-jump-input::-webkit-outer-spin-button,
.page-jump-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.page-jump-input[type=number] {
  -moz-appearance: textfield;
}

@media (max-width: 768px) {
  .pagination-center {
    gap: 8px;
  }
  .pagination button {
    padding: 8px 12px;
    font-size: 13px;
  }
  .page-info {
    font-size: 13px;
    margin: 0;
  }
  .page-jump-input {
    width: 40px;
    padding: 6px 4px;
    font-size: 13px;
  }
}
</style>